/**
 * @Author: abbeymart | Abi Akindele | @Created: 2020-09-25
 * @Company: Copyright 2020 Abi Akindele  | mConnect.biz
 * @License: All Rights Reserved | LICENSE.md
 * @Description: mc-central-ts: business routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const businessRoutes: Array<RouteRecordRaw> = [
  {
    path: '/business',
    name: 'business',
    redirect: '/business/solutions',
    component: () => import('pages/mc/McPage.vue'),
    meta: {
      title: 'mConnect Business Solutions & Services',
    },
    children: [
      {
        path: 'solutions',
        name: 'solutions',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Business Solutions',
        },
      },
      {
        path: 'microservices',
        name: 'microservices',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Microservices',
        },
      },
      {
        path: 'packages',
        name: 'packages',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Packages - Open Source',
        },
      },
      {
        path: 'subPricing',
        name: 'subPricing',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Subscription Pricing Model',
        },
      },
      {
        path: 'demos',
        name: 'demos',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Demos of Solutions & Services',
        },
      },
    ],
  },
];
